// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tgFiQaXWm1Q5KC2ffOmC{width:100%;max-height:250px;overflow-x:hidden;overflow-y:auto}.CijlCk8JZpIwsHTqYUcf{justify-content:flex-start;align-items:center;width:100%;padding:4px;display:flex}.XW_8hC1eNm87do__GOQD{margin-left:8px;margin-right:8px}.ZGkvXu92k7MTCw0wXrWM{margin-left:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `tgFiQaXWm1Q5KC2ffOmC`,
	"card": `CijlCk8JZpIwsHTqYUcf`,
	"name": `XW_8hC1eNm87do__GOQD`,
	"status": `ZGkvXu92k7MTCw0wXrWM`
};
export default ___CSS_LOADER_EXPORT___;
